import { AppContainer } from 'action-handler';
import 'core-js';
import 'whatwg-fetch';
import { App, AppProps } from './App';
import { Config } from './Config';
import de from './i18n/de.json';
import en from './i18n/en.json';
import it from './i18n/it.json';
import './index.css';
import { MainHandler } from './MainHandler';
import { Candidate } from './Model/Candidate';
import { JobVacancy } from './Model/JobVacancy';
import { Repository } from './Repository';
import { LocalizationUtility } from './Service/LocalizationUtility';
import { ReferenceIdBrowserStorage } from './Service/ReferenceIdBrowserStorage';
import { RestAdapterFactory } from './Service/RestAdapterFactory';
import { ServiceLocator } from './ServiceLocator';
import * as serviceWorker from './serviceWorker';

// Customize this:
type ModelType = Candidate | JobVacancy;

const serviceLocator = new ServiceLocator();
serviceLocator.registerMultiple(
    {
        config: () => {
            return Config.fromEnv();
        },

        restAdapterFactory: () => {
            return new RestAdapterFactory(serviceLocator);
        },

        adapter: () => {
            const factory: RestAdapterFactory = serviceLocator.get('restAdapterFactory');

            return factory.get();
        },

        candidateRepository: () => {
            const config = serviceLocator.get('config') as Config;
            const departmentId = config.departmentId;
            const resourceType = 'candidate' + (departmentId ? ('/' + departmentId) : '');

            return new Repository(Candidate, resourceType, serviceLocator.get('adapter'), config);
        },

        jobVacancyRepository: () => {
            const config = serviceLocator.get('config') as Config;
            const departmentId = config.departmentId;
            const resourceType = 'job-vacancy' + (departmentId ? ('/' + departmentId) : '');

            return new Repository(JobVacancy, resourceType, serviceLocator.get('adapter'), config);
        },

        handler: () => {
            return new MainHandler(serviceLocator);
        },

        referenceIdBrowserStorage: () => {
            return new ReferenceIdBrowserStorage();
        },

        i18n: () => {
            return new LocalizationUtility(serviceLocator.get('config'), serviceLocator.get('translations'));
        },
        translations: () => {
            const config: Config = serviceLocator.get('config');
            const language = config.twoLetterIsoCode;
            if (language === 'de') {
                return de;
            } else if (language === 'en') {
                return en;
            } else if (language === 'it') {
                return it;
            } else {
                return {};
            }
        }
    }
);

const handler: MainHandler<ModelType> = serviceLocator.get('handler');
const props: AppProps<ModelType> = {
    serviceLocator,
    handler
};

const appContainer = new AppContainer(handler);
const rootElement = document.getElementById('root');
if (rootElement) {
    console.info(`[JobCenter] Include as app (v ${(serviceLocator.get('config') as Config).version})`);
    appContainer.render(App, rootElement, props);
} else {
    console.info('[JobCenter] Include as library');
}
// @ts-ignore
window['JobCenter'] = {
    appContainer,
    serviceLocator,
    handler,
};

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
